import {
  SET_PAYMENT_ACTIVE_START,
  SET_PAYMENT_ACTIVE_END
} from "../constants";

const initialState = {
  isPaymentActive: false,
};

export default function paymentState(state = initialState, action) {
  switch (action.type) {
    case SET_PAYMENT_ACTIVE_START:
      return {
        ...state,
        isPaymentActive: true
      };

    case SET_PAYMENT_ACTIVE_END:
      return {
        ...state,
        isPaymentActive: false
      };

    default:
      return state;
  }
}
